import { useState } from 'react';
import type { ExecuteOnUcUiChangeProps } from '../loadingUCUI';
import { executeOnUcUiChange } from '../loadingUCUI';
import type { TEMPLATE_IDS } from '../templateIds';

export const getConsentByTemplateId = (templateId: TEMPLATE_IDS, updateCallback?: () => void): boolean => {
    const [hasConsent, setHasConsent] = useState(false);
    const updateConsent = () => {
        setHasConsent(!!window.UC_UI?.getServicesBaseInfo().find((data) => data.id === templateId)?.consent.status);
    };
    const executeProps: ExecuteOnUcUiChangeProps = {
        onSuccess: () => {
            updateConsent();
        },
        onUpdate: () => {
            updateConsent();

            if (updateCallback) {
                updateCallback();
            }
        }
    };
    executeOnUcUiChange(executeProps);

    return hasConsent;
};
